import { c as _c } from "react/compiler-runtime";
import { SellerUnitOne } from "@/components/sup/one";
import { SellerUnitOneSkeleton } from "@/components/sup/skeletons/seller-unit-one-skeleton";
import { SkeletonLoader } from "@/components/ui/skeleton";
import { useSupOne } from "@/hooks/use-sup-data";
import { usePropertyInteractionStore } from "@/stores/property-interaction";
import { MapItemSUP } from "@/types/search";
import { useEffect, useState } from "react";
interface PreferenceCarouselProps {
  supIds: string[];
  projectName?: string | null;
  onToggleFavorite?: (property: MapItemSUP) => void;
  onShortlist?: (property: MapItemSUP) => void;
  className?: string;
}
export function PreferenceCarousel(t0) {
  const $ = _c(21);
  const {
    supIds,
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const [currentIndex, setCurrentIndex] = useState(0);
  const overlaySupId = usePropertyInteractionStore(_temp);
  const {
    data: sups,
    loading,
    error
  } = useSupOne(supIds);
  let t2;
  let t3;
  if ($[0] !== currentIndex || $[1] !== overlaySupId || $[2] !== sups) {
    t2 = () => {
      if (overlaySupId && sups.length > 0) {
        const index = sups.findIndex(sup => sup._id === overlaySupId);
        if (index !== -1 && index !== currentIndex) {
          setCurrentIndex(index);
        }
      }
    };
    t3 = [overlaySupId, sups, currentIndex];
    $[0] = currentIndex;
    $[1] = overlaySupId;
    $[2] = sups;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  if (loading && sups?.length === 0) {
    const t4 = `w-full h-full ${className}`;
    let t5;
    let t6;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <div className="p-4 border-b border-gray-200"><SkeletonLoader height="20px" width="200px" /></div>;
      t6 = <SellerUnitOneSkeleton isInModal={true} />;
      $[5] = t5;
      $[6] = t6;
    } else {
      t5 = $[5];
      t6 = $[6];
    }
    let t7;
    if ($[7] !== t4) {
      t7 = <div className={t4}>{t5}{t6}</div>;
      $[7] = t4;
      $[8] = t7;
    } else {
      t7 = $[8];
    }
    return t7;
  }
  if (error && sups?.length === 0) {
    const t4 = `flex items-center justify-center h-64 ${className}`;
    let t5;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <div className="text-red-500">Error loading property details</div>;
      $[9] = t5;
    } else {
      t5 = $[9];
    }
    let t6;
    if ($[10] !== t4) {
      t6 = <div className={t4}>{t5}</div>;
      $[10] = t4;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    return t6;
  }
  if (!sups || sups.length === 0) {
    const t4 = `flex items-center justify-center h-64 ${className}`;
    let t5;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <div className="text-gray-500">No property data available</div>;
      $[12] = t5;
    } else {
      t5 = $[12];
    }
    let t6;
    if ($[13] !== t4) {
      t6 = <div className={t4}>{t5}</div>;
      $[13] = t4;
      $[14] = t6;
    } else {
      t6 = $[14];
    }
    return t6;
  }
  const currentSup = sups[currentIndex];
  const t4 = `w-full h-[90vh] flex flex-col ${className}`;
  let t5;
  if ($[15] !== currentSup || $[16] !== loading) {
    t5 = <div className="flex-1"><SellerUnitOne supOne={currentSup} className="border-0 shadow-none rounded-none h-full" isLoading={loading} isInModal={true} isInPreferenceCard={true} /></div>;
    $[15] = currentSup;
    $[16] = loading;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== t4 || $[19] !== t5) {
    t6 = <div className={t4}>{t5}</div>;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  return t6;
}
function _temp(state) {
  return state.overlaySupId;
}